const ADVENTURE = {
  init: function () {
    this.adventureLegal = document.querySelector('#adventure-legal');
    if (!this.adventureLegal) {
      return;
    }
    this.adventureButton = this.adventureLegal.parentNode.previousElementSibling;
    this.adventureLegal.addEventListener('click', this.toggle.bind(this));
  },

  toggle: function () {
    if (this.adventureLegal.checked) {
      this.adventureButton.removeAttribute('disabled');
    } else {
      this.adventureButton.setAttribute('disabled', '');
    }
  },
};

const ANNOUNCEMENT = {
  init: function () {
    this.counter = document.querySelector('.announcement-header time');
    if (!this.counter) {
      return;
    }
    this.endDate = this.counter.getAttribute('datetime');
    this.startCount();
  },

  startCount: function () {
    const end = new Date(this.endDate).getTime();
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = end - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        .toString()
        .padStart(2, '0');
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        .toString()
        .padStart(2, '0');
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)
        .toString()
        .padStart(2, '0');

      this.counter.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;

      if (distance < 0) {
        clearInterval(interval);
        this.counter.innerHTML = '¡El tiempo ha terminado!';
      }
    }, 1000);
  },
};

const BACKTOTOP = {
  init: function () {
    this.backToTop = document.getElementById('backToTop');

    window.addEventListener('scroll', this.toggleVisibility.bind(this));

    this.backToTop.addEventListener('click', function (event) {
      event.preventDefault();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  },

  toggleVisibility: function () {
    if (window.scrollY > window.innerHeight) {
      this.backToTop.style.opacity = 1;
    } else {
      this.backToTop.style.opacity = 0;
    }
  },
};

const CARD = {
  init: function () {
    const cardContainer = document.querySelector('.product-grid-container');
    if (!cardContainer) {
      return;
    }

    cardContainer.addEventListener('click', function (event) {
      const buttonAdd = event.target.closest('.product-card__actions button');
      if (buttonAdd) {
        const card = buttonAdd.closest('.product-card');
        CARD.toggleForm.call(card);
      }
    });

    cardContainer.addEventListener('submit', function (event) {
      const formAdd = event.target.closest('form');
      if (formAdd) {
        event.preventDefault();
        CARD.sendForm.call(formAdd, event);
      }
    });

    cardContainer.addEventListener('click', function (event) {
      const size = event.target.closest('input');
      if (size && size.type === 'radio') {
        const formAdd = size.closest('form');
        CARD.checkButton.call(formAdd);
      }
    });
  },

  toggleForm: function () {
    this.classList.toggle('product-card__add--is-visible');
  },

  sendForm: function (event) {
    event.preventDefault();
    const selected = this.querySelector('input:checked');
    if (selected) {
      const variantId = selected.value;
      CART.addItem(variantId, 1);
    }
    this.closest('.product-card').classList.remove('product-card__add--is-visible');
  },

  checkButton: function () {
    this.querySelector('button').removeAttribute('disabled');
  },
};

const CART = {
  init: function () {
    this.cart = document.querySelector('.cart');
    if (!this.cart) {
      return;
    }
    this.cart.addEventListener('click', this.checkBackdrop.bind(this));

    this.FREE_SHIPPING_THRESHOLD = window.marketConfig.marketValue;
    this.shopDomain = 'bluebanana-brand.myshopify.com';
    this.storefrontAccessToken = 'ea48fb70247e21b1e8b326df7a492830';

    this.buttonOpen = document.querySelector('.actions__cart button');
    this.badge = this.buttonOpen.querySelector('.badge');
    this.buttonOpen.addEventListener('click', this.show.bind(this));
    this.buttonClose = this.cart.querySelector(':scope > button');
    this.buttonClose.addEventListener('click', this.handleClose.bind(this));
    this.contentCart = document.getElementById('content-cart');
    this.contentModify = document.getElementById('content-modify');
    this.cartEmpty = document.querySelector('.cart__empty');
    this.cartEmptyButtons = document.querySelector('.cart__empty + .buttons__wrapper');
    this.cartMessageFilled = document.querySelector('.cart__message-filled');
    this.cartList = document.querySelector('.cart__products > .cart__list');
    this.cartListCrossSelling = document.querySelectorAll('.cart__cross-selling > .cart__list .button--is-secondary');
    this.cartItemTemplate = document.getElementById('cart-item-template');
    this.progressMessage = document.querySelector('.cart__message--is-progress p');
    this.progressBar = document.getElementById('cart__progress-bar');
    this.cartSubtotal = document.querySelector('.cart__summary dd');
    this.cartdiscountTotal = document.querySelector('.discount_total_price');
    this.buttonValidateDiscount = this.cart.querySelector('#code-validation');
    this.buttonValidateDiscount.addEventListener('click', this.validateCouponCode.bind(this));
    this.buttonSubmit = this.cart.querySelector('.cart__summary button#checkout');
    this.buttonSubmit.addEventListener('click', this.handleSubmit.bind(this));
    this.buttonClearDiscount = this.cart.querySelector('.cart__summary .delete-coupons');
    if (this.buttonClearDiscount !== null) {
      this.buttonClearDiscount.addEventListener('click', this.clearDiscount.bind(this));
    }

    this.bogoActivated = this.cart.dataset.promotionBogo === 'true' ? true : false;
    if (this.bogoActivated) {
      this.priceBogo = this.cart.dataset.priceBogo;
      this.messageBefore = document.getElementById('message-keep-buying');
      this.messageAfter = document.getElementById('message-product-in-cart');
      this.bogoForm = document.querySelector('.cart__message--has-suggestion');
      this.promotionProductId = this.cart.dataset.promotionId.toString();
    }
    this.updateCart();
    this.handleDiscountAccordion();
    this.checkDiscountCode.bind(this)();

    if (this.cartListCrossSelling) {
      this.cartListCrossSelling.forEach((crossSellingItem) => {
        crossSellingItem.addEventListener('click', (event) => {
          event.preventDefault();
          const previousInput = crossSellingItem.previousElementSibling;
          const variantId = previousInput.value;
          CART.addItem(variantId, 1);
        });
      });
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList.contains('docapp-overlay-modal')) {
              CART.hide();
            }
          });
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },

  addItem: async function (variantId, quantity) {
    const validatedQuantity = Math.min(10, quantity);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: validatedQuantity }] }),
      }).then((response) => console.log(response));
      this.addProductPopup(variantId);
      CART.updateCart();
    } catch (error) {
      console.error('Error al añadir el producto:', error);
    }
  },
  handleDiscountAccordion: function () {
    document.querySelectorAll('.accordion-expand .accordion-header').forEach((header) => {
      header.addEventListener('click', function (event) {
        const section = this.nextElementSibling;
        const openSection = document.querySelector('.accordion-expand .accordion-content[style*="max-height"]');
        const iconElem = event.currentTarget.querySelector('.icon');
        const icon = iconElem.innerHTML;

        if (openSection && openSection !== section) {
          openSection.style.maxHeight = null;
        }

        section.style.maxHeight = section.style.maxHeight ? null : `${section.scrollHeight}px`;
        icon === '+' ? (iconElem.innerHTML = '-') : (iconElem.innerHTML = '+');
      });
    });
  },
  checkDiscountCode: function () {
    document.querySelector('#discount-code').addEventListener(
      'input',
      debounce((event) => {
        const target = event.target;
        const targetValue = target.value.trim();

        if (targetValue) {
          this.buttonValidateDiscount.removeAttribute('disabled');
        } else {
          this.buttonValidateDiscount.setAttribute('disabled', '');
        }
      }, 500)
    );
  },
  validateCouponCode: function () {
    this.buttonSubmit.setAttribute('disabled', '');

    try {
      fetch('/payments/config', { method: 'GET' })
        .then(function (response) {
          return response.json();
        })
        .then(function (paymentsData) {
          const checkout_json_url = '/wallets/checkouts/';
          authorization_token = btoa(paymentsData.paymentInstruments.accessToken);
          fetch('/cart.js', {})
            .then(function (res) {
              return res.json();
            })
            .then(function (cartData) {
              const discountCode = document.querySelector('#discount-code').value.trim();
              const headers = {
                accept: '*/*',
                'cache-control': 'no-cache',
                authorization: 'Basic ' + authorization_token,
                'content-type': 'application/json, text/javascript',
                pragma: 'no-cache',
                'sec-fetch-dest': 'empty',
                'sec-fetch-mode': 'same-origin',
                'sec-fetch-site': 'same-origin',
              };
              let body = {
                checkout: {
                  country: Shopify.country,
                  discount_code: discountCode,
                  line_items: cartData.items,
                  presentment_currency: Shopify.currency.active,
                },
              };

              fetch(checkout_json_url, {
                headers: headers,
                referrerPolicy: 'strict-origin-when-cross-origin',
                'Access-Control-Allow-Origin': '*',
                method: 'POST',
                mode: 'same-origin',
                credentials: 'include',
                body: JSON.stringify(body),
              })
                .then(function (response) {
                  return response.json();
                })
                .then(function (checkoutData) {
                  const inputError = document.querySelector('.discount-code-container .input-error');

                  let discountApplyUrl = '/discount/' + discountCode + '?v=' + Date.now() + '&redirect=/checkout/';
                  fetch(discountApplyUrl, {})
                    .then(function (discountData) {
                      document.querySelector('.cart__summary button#checkout').removeAttribute('disabled');

                      if (checkoutData.checkout && checkoutData.checkout.applied_discounts.length > 0) {
                        // CART.updateCart();
                        location.reload();
                      }

                      if ('errors' in checkoutData) {
                        const discountsContent = document.querySelector('.accordion-content');

                        inputError.innerHTML = checkoutData.errors.discount_code[0].message;
                        inputError.classList.add('block');
                        discountsContent.style.maxHeight = discountsContent.scrollHeight + 40 + 'px';
                      }
                    })
                    .catch((error) => {
                      document.querySelector('.cart__summary button#checkout').removeAttribute('disabled');
                      console.error('Error al aplicar el cupon:', error);
                    });
                });
            });
        });
    } catch (error) {
      console.log(error);
    }
  },
  clearDiscount: function () {
    fetch('/discount/CLEAR').then(function () {
      location.reload();
    });
  },

  checkBackdrop: function (event) {
    const rect = this.cart.getBoundingClientRect();
    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      this.hide();
    }
  },

  checkBOGO: function (totalPrice, cartItems) {
    let promotionProductInCart = false;
    let valueOfPromotionProduct;
    for (let item of cartItems) {
      if (item.variant_id.toString() === this.promotionProductId) {
        promotionProductInCart = true;
        valueOfPromotionProduct = item.final_line_price;
        break;
      }
    }
    if (totalPrice / 100 >= this.priceBogo) {
      if (promotionProductInCart) {
        this.messageBefore.style.display = 'none';
        this.bogoForm.style.display = 'none';
        this.messageAfter.style.display = 'block';
        if (valueOfPromotionProduct === 0) {
          this.messageAfter.innerHTML = `<p>${this.cart.dataset.messageProductInCart}</p>`;
        } else {
          this.messageAfter.innerHTML = `<p>${this.cart.dataset.messageMissingAmountCart.replace(
            'MISSING_AMOUNT',
            (valueOfPromotionProduct / 100).toFixed(2).replace('.', ',')
          )}</p>`;
        }
      } else {
        this.messageBefore.style.display = 'none';
        this.bogoForm.style.display = 'block';
        this.messageAfter.style.display = 'none';
      }
    } else {
      const missingAmount = (this.priceBogo - totalPrice / 100).toFixed(2).replace('.', ',');
      if (promotionProductInCart) {
        this.messageBefore.style.display = 'block';
        this.messageBefore.innerHTML = `<p>${this.cart.dataset.messageMissingAmountCart.replace(
          'MISSING_AMOUNT',
          missingAmount
        )}</p>`;
        this.bogoForm.style.display = 'none';
        this.messageAfter.style.display = 'none';
      } else {
        this.messageBefore.style.display = 'block';
        this.messageBefore.innerHTML = `<p>${this.cart.dataset.messageMissingAmountNoCart.replace(
          'MISSING_AMOUNT',
          missingAmount
        )}</p>`;
        this.bogoForm.style.display = 'none';
        this.messageAfter.style.display = 'none';
      }
    }
  },

  checkElementsNumber: function (items) {
    const sum = items.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0);
    if (items.length === 0) {
      this.cartEmpty.removeAttribute('hidden');
      this.cartEmptyButtons.classList.remove('visually-hidden');
      this.cartMessageFilled.setAttribute('hidden', '');
      this.badge.textContent = '';
      this.buttonSubmit.setAttribute('disabled', '');
    } else {
      this.cartEmpty.setAttribute('hidden', '');
      this.cartEmptyButtons.classList.add('visually-hidden');
      this.cartMessageFilled.removeAttribute('hidden', '');
      this.badge.textContent = sum;
      this.buttonSubmit.removeAttribute('disabled');
    }
  },

  handleClose: function () {
    if (this.contentCart.hasAttribute('hidden')) {
      CART.hideModify();
    } else {
      CART.hide();
    }
  },

  handleSubmit: function () {
    window.location.href = '/checkout';
  },

  hide: function () {
    this.cart.close();
  },

  hideModify: function () {
    this.contentCart.removeAttribute('hidden');
    this.contentModify.setAttribute('hidden', '');
  },

  modifyItem: function (productId, line, variantTitle) {
    const graphqlId = btoa(`gid://shopify/Product/${productId}`);
    const apiUrl = `https://${this.shopDomain}/api/2024-04/graphql.json`;
    const query = `
    {
      node(id: "${graphqlId}") {
        ... on Product {
          id
          title
          handle
          description
          tags
          newPhotos: metafield(key: "new_photos", namespace: "custom") {
            value
            references(first: 10) {
              edges {
                node {
                  ... on MediaImage {
                    id
                    image {
                      originalSrc
                    }
                  }
                }
              }
            }
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          images(first: 50) {
            edges {
              node {
                originalSrc
                altText
              }
            }
          }
          collections(first: 50) {
            edges {
              node {
                id
                title
                handle
              }
            }
          }
          variants(first: 50) {
            edges {
              node {
                id
                title
                availableForSale
                priceV2 {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }`;
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
      },
      body: JSON.stringify({ query }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && data.data.node) {
          const product = data.data.node;
          let mainCollection = null;

          if (product.tags) {
            for (const tag of product.tags) {
              // Usamos un bucle for...of en lugar de forEach
              if (tag.startsWith('collection-')) {
                const mainCollectionHandle = tag.replace('collection-', '');

                // Verifica que product.collections.edges sea un array antes de buscar
                if (product.collections && Array.isArray(product.collections.edges)) {
                  mainCollection = product.collections.edges.find(
                    (edge) => edge.node && edge.node.handle === mainCollectionHandle
                  );

                  if (mainCollection) {
                    // Si encontramos la colección, rompemos el bucle
                    break;
                  }
                }
              }
            }
          }

          if (mainCollection) {
            const collectionGraphqlId = mainCollection.node.id;
            const collectionQuery = `
            {
              node(id: "${collectionGraphqlId}") {
                ... on Collection {
                  title
                  products(first: 50) {
                    edges {
                      node {
                        id
                        title
                        handle
                        availableForSale
                        images(first: 50) {
                          edges {
                            node {
                              originalSrc
                              altText
                            }
                          }
                        }
                        variants(first: 50) {
                          edges {
                            node {
                              id
                              title
                              availableForSale
                              priceV2 {
                                amount
                                currencyCode
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`;

            fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
              },
              body: JSON.stringify({
                query: collectionQuery,
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                const collectionResponse = data;

                if (collectionResponse.data && collectionResponse.data.node) {
                  const collectionProducts = collectionResponse.data.node.products.edges.map((edge) => edge.node);
                  CART.showModify(product, collectionProducts, line, variantTitle);
                } else {
                  console.log('No se encontraron productos para esta colección.');
                }
              });
          } else {
            console.log('No se encontró una colección principal.');
          }
        } else {
          console.log('No se encontraron datos del producto.');
        }
      })
      .catch((error) => {
        console.log('Error al obtener la información:', error);
      });
  },

  modifyReplace: function (line, selectedVariant) {
    const quantity = 1;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        quantity: 0,
        line: line,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            quantity: quantity,
            id: selectedVariant,
          }),
        });
      })
      .then((response) => response.json())
      .then(() => {
        CART.updateCart();
      })
      .catch((error) => {
        console.error('Error cambiando la variante del producto:', error);
      });
  },

  refreshLoyaltyLion: function (priceCart) {
    if (window.loyaltylion && window.loyaltylion.ui) {
      const llCart = document.querySelector('.cart__message--is-loyalty strong');
      if (llCart) {
        llCart.setAttribute('data-lion-points-for', priceCart);
        window.loyaltylion.ui.refresh();
      }
    } else {
      console.error('loyaltylion.ui no está definido');
    }
  },

  removeItem: function (itemId) {
    const updates = {};
    const items = this.cartList.querySelectorAll(':scope > li');

    items.forEach((item) => {
      const input = item.querySelector('input');
      const id = input.dataset.itemId;
      const quantity = parseInt(input.value);
      updates[id] = quantity;
    });

    updates[itemId] = 0;
    CART.updateLine(updates);
  },

  renderItems: function (items) {
    this.cartList.innerHTML = '';

    items.forEach((item, index) => {
      let indexItem = index + 1;
      const cloned = this.cartItemTemplate.content.cloneNode(true);
      const image = cloned.querySelector('.cart-item__image a img');
      const title = cloned.querySelector('dt a');
      const originalPrice = cloned.querySelector('del');
      const price = cloned.querySelector('dd');
      const quantity = cloned.querySelector('input');
      const remove = cloned.querySelector('button[value="remove"]');
      const modify = cloned.querySelector('button[value="modify"]');
      const decrease = cloned.querySelector('button.sub');
      const increase = cloned.querySelector('button.add');

      image.src = item.image;
      image.alt = item.title;
      image.parentElement.href = item.url;

      title.textContent = item.title;
      title.href = item.url;

      if (item.compare_at_price > item.final_line_price) {
        price.innerHTML = `
          <del>${(item.compare_at_price / 100).toFixed(2).replace('.', ',')} €</del>
          ${(item.final_line_price / 100).toFixed(2).replace('.', ',')} €
        `;
      } else {
        price.textContent = `${(item.final_line_price / 100).toFixed(2).replace('.', ',')} €`;
      }

      if (item.line_level_discount_allocations.length > 0) {
        item.line_level_discount_allocations.forEach((discount) => {
          const discountElement = document.createElement('p');
          discountElement.style = 'display: flex; align-items: center; gap: 8px;';
          discountElement.innerHTML = `
            <svg
              style="width: 15px; height: 15px;"
              aria-hidden="true"
              focusable="false"
              class="icon icon-discount"
              viewBox="0 0 12 12"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
            </svg>
            ${discount.discount_application.title}
          `;
          price.appendChild(discountElement);
        });
      }

      quantity.value = item.quantity;
      quantity.dataset.itemId = item.id;

      modify.dataset.productId = item.product_id;
      modify.dataset.line = indexItem;

      if (item.product_type == 'Gift') {
        cloned.querySelector('li').classList.add('gift-item');
      }

      quantity.addEventListener('change', () => {
        const newQuantity = Math.min(10, parseInt(quantity.value) || 1);
        quantity.value = newQuantity;
        CART.updateQuantity(item.id, newQuantity);
      });

      decrease.addEventListener('click', () => {
        const newQuantity = Math.max(1, parseInt(quantity.value) - 1);
        quantity.value = newQuantity;
        CART.updateQuantity(item.id, newQuantity);
      });

      increase.addEventListener('click', () => {
        const newQuantity = Math.min(10, parseInt(quantity.value) + 1);
        quantity.value = newQuantity;
        CART.updateQuantity(item.id, newQuantity);
      });

      remove.addEventListener('click', () => CART.removeItem(item.id));
      modify.addEventListener('click', () => CART.modifyItem(item.product_id, indexItem, item.variant_title));

      this.cartList.appendChild(cloned);
    });

    CART.checkElementsNumber(items);
  },

  show: function () {
    this.cart.showModal();
  },

  showModify: function (product, collectionProducts, line, variantTitle) {
    const updateCartButton = this.contentModify.querySelector('button');
    const containerVariants = this.contentModify.querySelector('.modify-product-size div');
    const containerCollection = document.querySelector('.modify-product-color__list');

    let amount = product.priceRange.maxVariantPrice.amount;
    const formattedAmount = parseFloat(amount).toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    document.querySelector('#content-modify .product-detail__image  .product__images').innerHTML = '';

    this.contentModify.querySelector('.product-detail__name').textContent = product.title;

    // check images and create a gallery carousel
    product?.images?.edges.forEach((image) => {
      const imgListContainer = document.querySelector('#content-modify .product-detail__image  .product__images');
      const imageSrc = image.node.originalSrc;
      const imageAlt = image.node.altText !== null ? image.node.altText : product.title;

      imgListContainer.insertAdjacentHTML('beforeend', `<li><img src="${imageSrc}" alt="${imageAlt}"></li>`);
    });
    // create price amount data
    this.contentModify.querySelector('.product-detail__price').textContent = formattedAmount + ' €';

    containerVariants.innerHTML = '';

    product.variants.edges.forEach((variant, index) => {
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'cart__variant';
      input.value = variant.node.id.split('/').pop();
      input.id = `cart__variant--is-${index}`;
      input.classList.add('visually-hidden');

      if (
        (!variant.node.availableForSale || variant.node.quantityAvailable === 0) &&
        variant.node.title.toLowerCase() === 'default title'
      ) {
        input.disabled = true;
        variant.node.title = '-';
      } else if (!variant.node.availableForSale || variant.node.quantityAvailable === 0) {
        input.disabled = true;
      } else if (variant.node.title === variantTitle) {
        input.checked = true;
      } else if (variant.node.title.toLowerCase() === 'default title') {
        variant.node.title = '-';
        input.checked = true;
      }

      const label = document.createElement('label');
      label.htmlFor = `cart__variant--is-${index}`;
      label.textContent = `${variant.node.title}`;

      containerVariants.appendChild(input);
      containerVariants.appendChild(label);
    });

    if (containerCollection) {
      containerCollection.innerHTML = '';

      collectionProducts.forEach((item) => {
        const itemContainer = document.createElement('li');
        const itemElement = document.createElement('button');
        const itemID = item.id.match(/\d+/)[0];

        if (product.id.includes(itemID)) {
          itemContainer.classList.add('product-item--is-selected');
        }
        itemElement.type = 'button';

        itemElement.addEventListener('click', () => {
          CART.modifyItem(itemID, line);
        });

        if (item.images.edges.length > 0) {
          const image = document.createElement('img');
          image.src = item.images.edges[0].node.originalSrc;
          image.alt = item.title;
          itemElement.appendChild(image);
        }

        itemContainer.appendChild(itemElement);
        containerCollection.appendChild(itemContainer);
      });
    }

    updateCartButton.onclick = async function (event) {
      event.preventDefault();
      const selectedVariant = document.querySelector('input[name="cart__variant"]:checked').value;
      await CART.modifyReplace(line, selectedVariant);
      CART.hideModify();
    };

    this.contentCart.setAttribute('hidden', '');
    this.contentModify.removeAttribute('hidden');
  },
  addProductPopup: async function (productId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const items = cart.items;
      const addCartPopup = document.getElementById('popup-add-to-cart');

      for (const item of items) {
        if (item.id === parseInt(productId, 10)) {
          addCartPopup.querySelector('.popup-content').innerHTML = `
            <div class="product-image">
              <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="product-info">
              <p>${item.product_title}</p>
              <p>Talla: ${item.variant_title}</p>
              <a href="#" class="cart-url">VER CARRITO</a>
            </div>
          `;
        }
      }

      const cartLink = addCartPopup.querySelector('.cart-url');
      if (cartLink !== null) {
        cartLink.addEventListener('click', () => {
          this.cart.showModal();
        });
      }

      addCartPopup.classList.add('open');
      setTimeout(() => {
        addCartPopup.classList.remove('open');
      }, 3000);
    } catch (error) {
      console.error('Error al obtener el carrito:', error);
    }
  },

  updateCart: async function () {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const items = cart.items;

      for (const item of items) {
        const productHandle = item.handle;
        const variantId = item.variant_id;

        const productResponse = await fetch(`/products/${productHandle}.js`);
        const product = await productResponse.json();
        const variant = product.variants.find((v) => v.id === variantId);
        if (variant) item.compare_at_price = variant.compare_at_price;
      }

      CART.renderItems(items);
      CART.updateSubtotal(cart.total_price, items);
      CART.updateDiscountTotal(cart.original_total_price, items);
      CART.updateProgress(cart.total_price);
      CART.refreshLoyaltyLion(cart.total_price);
    } catch (error) {
      console.error('Error al obtener el carrito:', error);
    }
  },

  updateLine: async function (updates) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      CART.updateCart();
    } catch (error) {
      console.error('Error al actualizar las líneas:', error);
    }
  },

  updateProgress: function (totalPrice) {
    const progressMessage = document.querySelector('.cart__message--is-progress p');
    const remainingAmount = this.FREE_SHIPPING_THRESHOLD - totalPrice;
    const progress = (totalPrice / this.FREE_SHIPPING_THRESHOLD) * 100;
    const freShippingQty1 = document.querySelector('.cart').getAttribute('data-message-free-shipping-qty-1');
    const freShippingQty2 = document.querySelector('.cart').getAttribute('data-message-free-shipping-qty-2');
    const freeShipping = document.querySelector('.cart').getAttribute('data-message-free-shipping');
    const percentage = Math.min(100, progress).toFixed(2);

    if (remainingAmount > 0) {
      progressMessage.textContent = `${freShippingQty1} ${(remainingAmount / 100).toFixed(2)} ${freShippingQty2}`;
    } else {
      progressMessage.textContent = freeShipping;
    }

    this.progressBar.value = percentage;
    this.progressBar.innerHTML = `${percentage}%`;
  },

  updateQuantity: function (itemId, newQuantity) {
    const updates = {};
    const items = this.cartList.querySelectorAll(':scope > li');
    const itemsQtyButtons = this.cartList.querySelectorAll(':scope > li .cart-item__quantity button');

    items.forEach((item) => {
      const input = item.querySelector('input');
      const id = input.dataset.itemId;
      const quantity = Math.min(10, parseInt(input.value) || 1);
      updates[id] = quantity;
    });

    updates[itemId] = Math.min(10, parseInt(newQuantity) || 1);
    CART.updateLine(updates);
  },

  updateSubtotal: function (totalPrice, cartItems) {
    this.cartSubtotal.textContent = `${(totalPrice / 100).toFixed(2).replace('.', ',')} €`;

    if (this.bogoActivated) {
      CART.checkBOGO(totalPrice, cartItems);
    }
  },
  updateDiscountTotal: function (totalPrice, cartItems) {
    if (this.cartdiscountTotal) {
      this.cartdiscountTotal.textContent = `${(totalPrice / 100).toFixed(2).replace('.', ',')} €`;
    }
  },
};

const COLLAPSIBLE = {
  init: function () {
    this.collapsibleContent = document.querySelectorAll('.collapsible-wrapper');
    if (!this.collapsibleContent) {
      return;
    }

    const buttons = document.querySelectorAll('.collapsible-wrapper__button');
    buttons.forEach((element) => {
      element.addEventListener('click', () => {
        element.classList.toggle('button-active');
        const parentDiv = element.closest('.collapsible-parent');
        const targetElement = parentDiv.querySelector('.collapsible-wrapper');
        this.toggleContent(targetElement);
      });
    });
  },

  toggleContent: function (target) {
    target.classList.toggle('active');

    window.scroll({
      top: target.offsetTop,
      left: 0,
      behavior: 'smooth',
    });
  },
};

const FOOTER = {
  init: function () {
    this.menus = document.querySelectorAll('.footer__menu');
    if (!this.menus) {
      return;
    }
    this.menus.forEach((menu) => {
      menu.querySelector('dt').addEventListener('click', this.toggle.bind(menu));
    });
  },

  toggle: function () {
    this.classList.toggle('footer__menu--is-active');
  },
};

const HORIZONTALSCROLL = {
  init: function () {
    const isDesktop = window.innerWidth > 900;
    this.sliders = document.querySelectorAll('.has-custom-scroll-x');
    if (isDesktop && this.sliders.length) {
      this.sliders.forEach((slider) => {
        this.setupSlider(slider);
      });
    }

    const interval = setInterval(() => {
      const loyaltyLionSliderReward = document.querySelector('[data-lion-rewards-list] > div');
      const loyaltyLionSliderRules = document.querySelector('[data-lion-rules-list] > div');
      if (loyaltyLionSliderReward && loyaltyLionSliderRules) {
        this.setupSlider(loyaltyLionSliderReward);
        this.setupSlider(loyaltyLionSliderRules);
        clearInterval(interval);
      }
    }, 500);
  },

  setupSlider: function (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('is-dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault();
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3;
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    slider.addEventListener('selectstart', (e) => {
      e.preventDefault();
    });
  },
  scrollToItem: function (slider, itemIndex) {
    const items = slider.children;
    if (items.length === 0 || itemIndex < 0 || itemIndex >= items.length) {
      return;
    }
    const itemWidth = items[0].offsetWidth;
    const scrollAmount = itemWidth * itemIndex;
    slider.scrollLeft = scrollAmount;
  },
};

const LANGUAGE = {
  init: function () {
    this.selectors = document.querySelectorAll('.language__list');
    if (!this.selectors.length) {
      return;
    }
    this.selectors.forEach((selector) => {
      const selected = selector.querySelector('.language__list--is-selected button');
      selected.addEventListener('click', this.toggle.bind(selector));
    });
  },

  toggle: function () {
    this.classList.toggle('language__list--is-active');
  },
};

const MENU = {
  init: function () {
    this.header = document.querySelector('.header');
    if (!this.header) {
      return;
    }
    const buttonMenu = document.querySelector('.button__menu');
    buttonMenu.addEventListener('click', this.togglePrimary.bind(this));

    const primaryItems = document.querySelectorAll('.menu__primary > li > button');
    primaryItems.forEach((item) => {
      item.addEventListener('click', this.toggleSecondary.bind(item));
    });

    const secondaryItems = document.querySelectorAll('.menu__secondary > li > button');
    secondaryItems.forEach((item) => {
      item.addEventListener('click', this.toggleTertiary.bind(item));
    });

    const buttonsBack = document.querySelectorAll('.button__back button');
    buttonsBack.forEach((button) => {
      button.addEventListener('click', this.hideTertiary.bind(button));
    });

    const bannerButtonMan = document.getElementById('man-sales');
    const bannerButtonWoman = document.getElementById('woman-sales');
    if (bannerButtonMan || bannerButtonWoman) {
      this.toggleMenuBehavior();
    }

    const menuActiveItems = document.querySelectorAll('.menu-mobile__active-item');
    if (menuActiveItems.length > 0) {
      this.activeMenuMobile(menuActiveItems[0]);
    }

    // Desktop close button
    const menuCloseButton = document.querySelectorAll('.header .button-close');
    menuCloseButton.forEach((button) => {
      if (button) {
        button.addEventListener('click', this.handleClose.bind(this));
      }
    });

    this.headerMarquee = document.querySelector('.section-header .marquee');
    if (this.headerMarquee) {
      this.marqueesBottomOffset();
      window.addEventListener('scroll', this.marqueesBottomOffset.bind(this));
      window.addEventListener('resize', this.marqueesBottomOffset.bind(this));
    }
  },

  activeMenuMobile: function (menuActiveItem) {
    const breakpoint = 900;
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < breakpoint;

    const secondLevelMenu = menuActiveItem.parentNode.classList.contains('menu__secondary');
    if (secondLevelMenu && isMobile) {
      const parentLiItem = menuActiveItem.parentNode.closest('li');
      parentLiItem.classList.add('menu__secondary--is-active');
    }

    const thirdLevelMenu = menuActiveItem.parentNode.classList.contains('menu__tertiary');
    if (thirdLevelMenu) {
      const parentLiItem = menuActiveItem.parentNode.closest('li');
      parentLiItem.classList.add('menu__tertiary--is-active');

      if (isMobile) {
        const grandParentLiItem = parentLiItem.parentNode.closest('li');
        grandParentLiItem.classList.add('menu__secondary--is-active');
      }
    }
  },

  togglePrimary: function () {
    this.header.classList.toggle('header--has-menu-active');
    const breakpoint = 900;
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < breakpoint;
    const isCollection = document.querySelector('nav[data-is-collection]');

    if (isMobile && !isCollection) {
      const itemMan = document.querySelector('.menu__primary > li:nth-child(1)');
      itemMan.classList.toggle('menu__secondary--is-active');
    }

    // Add this block to prevent body scrolling
    if (this.header.classList.contains('header--has-menu-active')) {
      document.body.classList.add('no-scroll');
      // New feature: Activate first menu item if no active item
      const activeItem = document.querySelector('.menu-mobile__active-item');
      if (!activeItem) {
        const firstMenuItem = document.querySelector('.menu__primary > li:first-child');
        if (firstMenuItem) {
          firstMenuItem.classList.add('menu__secondary--is-active');
          const firstMenuItemButton = firstMenuItem.querySelector('button');
          if (firstMenuItemButton) {
            this.toggleSecondary.call(firstMenuItemButton);
          }
        }
      }
    } else {
      document.body.classList.remove('no-scroll');
    }
  },

  toggleMenuBehavior: function () {
    const breakpoint = 900;

    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < breakpoint;

    const buttonMenu = document.querySelector('.button__menu');

    const itemMan = document.querySelector('.menu__primary > li:nth-child(1)');
    const itemWoman = document.querySelector('.menu__primary > li:nth-child(2)');

    const buttonMan = itemMan.querySelector(':scope > button');
    const buttonWoman = itemWoman.querySelector(':scope > button');

    const buttonSalesMan = itemMan.querySelector('.menu__secondary > li:nth-child(1) > button');
    const buttonSalesWoman = itemWoman.querySelector('.menu__secondary > li:nth-child(1) > button');

    const bannerButtonMan = document.getElementById('man-sales');
    const bannerButtonWoman = document.getElementById('woman-sales');

    if (bannerButtonMan) {
      bannerButtonMan.addEventListener('click', function () {
        if (isMobile) {
          buttonMenu.click();
        }
        if (!buttonMan.parentNode.classList.contains('menu__secondary--is-active')) {
          buttonMan.click();
        }
        if (!buttonSalesMan.parentNode.classList.contains('menu__tertiary--is-active')) {
          buttonSalesMan.click();
        }
      });
    }

    if (bannerButtonWoman) {
      bannerButtonWoman.addEventListener('click', function () {
        if (isMobile) {
          buttonMenu.click();
        }
        if (!buttonWoman.parentNode.classList.contains('menu__secondary--is-active')) {
          buttonWoman.click();
        }
        if (!buttonSalesWoman.parentNode.classList.contains('menu__tertiary--is-active')) {
          buttonSalesWoman.click();
        }
      });
    }
  },

  toggleSecondary: function () {
    document.body.classList.add('no-scroll');

    const showed = this.closest('ul').querySelector('.menu__secondary--is-active');
    const selected = this.closest('li');

    // If the clicked item is already active, do nothing
    if (selected.classList.contains('menu__secondary--is-active')) {
      return;
    }

    if (showed && showed !== selected) {
      showed.classList.remove('menu__secondary--is-active');
      const interactiveElements = showed.querySelectorAll(
        '.menu__wrapper--is-secondary button, .menu__wrapper--is-secondary a'
      );
      MENU.addTabindex(interactiveElements);
    }

    selected.classList.add('menu__secondary--is-active');
    const interactiveElements = selected.querySelectorAll('.wrapper > ul > li > button, .wrapper > ul > li > a');
    MENU.removeTabindex(interactiveElements);
  },

  toggleTertiary: function () {
    const showed = this.closest('ul').querySelector('.menu__tertiary--is-active');
    const selected = this.closest('li');
    if (showed && showed !== selected) {
      showed.classList.remove('menu__tertiary--is-active');
      const interactiveElements = showed.querySelectorAll('.menu__tertiary a');
      MENU.addTabindex(interactiveElements);
    }
    selected.classList.toggle('menu__tertiary--is-active');
    const interactiveElements = selected.querySelectorAll('.menu__tertiary a');
    const isActive = selected.classList.contains('menu__tertiary--is-active');
    if (isActive) {
      MENU.removeTabindex(interactiveElements);
    } else {
      MENU.addTabindex(interactiveElements);
    }
  },

  hideTertiary: function () {
    this.closest('li').querySelector('.menu__tertiary--is-active').classList.remove('menu__tertiary--is-active');
  },

  addTabindex: function (elements) {
    elements.forEach((element) => {
      element.setAttribute('tabindex', '-1');
    });
  },

  removeTabindex: function (elements) {
    elements.forEach((element) => {
      element.removeAttribute('tabindex');
    });
  },

  handleClose: function () {
    const activeSecondaryMenu = document.querySelector('.menu__secondary--is-active');
    if (activeSecondaryMenu) {
      activeSecondaryMenu.classList.remove('menu__secondary--is-active');
      const interactiveElements = activeSecondaryMenu.querySelectorAll(
        '.menu__wrapper--is-secondary button, .menu__wrapper--is-secondary a'
      );
      this.addTabindex(interactiveElements);
    }
    document.body.classList.remove('no-scroll');
    this.header.classList.remove('header--has-menu-active');
  },

  marqueesBottomOffset: function () {
    document.body.style.setProperty(
      '--header-marquee-offset',
      this.headerMarquee.getBoundingClientRect().bottom > 0
        ? `${this.headerMarquee.getBoundingClientRect().bottom}px`
        : '0px'
    );
  },
};

const PRODUCT = {
  init: function () {
    this.product = document.querySelector('.product__actions');
    if (!this.product) {
      return;
    }
    this.buttons = this.product.querySelectorAll('.button--is-primary');
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.addToCart);
    });
  },

  addToCart: function (event) {
    event.preventDefault();
    const variantId = this.closest('form').querySelector('input:checked').value;
    CART.addItem(variantId, 1);
  },
};

const STATICBANNERTOGGLE = {
  init: function () {
    this.staticBanner = document.querySelector('.static-banner-thumbs');
    if (!this.staticBanner) {
      return;
    }
    const staticBannerThumbs = this.staticBanner.querySelectorAll('.banners__list li');
    let currentIndex = 0;

    const clickNextThumb = () => {
      staticBannerThumbs[currentIndex].click();
      currentIndex = (currentIndex + 1) % staticBannerThumbs.length;
    };

    staticBannerThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        const video = thumb.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        const dataBlock = thumb.getAttribute('data-block');
        const wrapper = document.querySelector(`.static-banner-thumbs__wrapper[data-block="${dataBlock}"]`);
        if (wrapper) {
          const wrapperVideo = wrapper.querySelector('video');
          if (wrapperVideo) {
            wrapperVideo.pause();
            wrapperVideo.currentTime = 0;
          }
        }

        this.show.call(thumb);
      });

      const video = thumb.querySelector('video');
      if (video) {
        video.loop = false;
        video.addEventListener('ended', () => {
          setTimeout(clickNextThumb, 300);
        });
      }
    });

    clickNextThumb();
  },

  show: function () {
    const wrappers = document.querySelectorAll('.static-banner-thumbs__wrapper');
    const videos = document.querySelectorAll('.static-banner-thumbs__wrapper .static-banner-block__video');
    const bannerItems = document.querySelectorAll('.banners__list li');

    if (wrappers.length > 0) {
      wrappers.forEach((wrapper) => wrapper.classList.remove('active'));
    }

    if (videos.length > 0) {
      videos.forEach((video) => {
        if (video instanceof HTMLVideoElement) {
          video.pause();
        }
        video.classList.remove('active-video');
      });
    }

    if (bannerItems.length > 0) {
      bannerItems.forEach((item) => {
        const itemVideos = item.querySelectorAll('video');
        itemVideos.forEach((video) => {
          if (video instanceof HTMLVideoElement) {
            video.pause();
          }
        });
        item.classList.remove('banners__item--is-selected', 'active-video');
      });
    }

    const targetWrapper = document.querySelector(`.static-banner-thumbs__wrapper[data-block="${this.dataset.block}"]`);
    const targetVideo = document.querySelector(
      `.static-banner-thumbs__wrapper[data-block="${this.dataset.block}"] .static-banner-block__video`
    );

    if (targetWrapper) {
      targetWrapper.classList.add('active');
    }

    if (targetVideo) {
      targetVideo.classList.add('active-video');
    }

    this.classList.add('banners__item--is-selected', 'active-video');

    VIDEO.init();
  },
};

const SLIDER = {
  init: function () {
    this.slider = document.querySelector('.home-slider');
    if (!this.slider) {
      return;
    }
    const buttons = this.slider.querySelectorAll('button[data-variant-id]');
    buttons.forEach((button) => {
      button.addEventListener('click', this.addToCart.bind(button));
    });
    this.sliderList = this.slider.querySelector('.home-slider__list')
    this.slider.querySelectorAll('.home-slider--navigation button').forEach(button => {
      button.addEventListener('click', this.onNavigationClick.bind(this))
    })
    this.onListScroll();
    this.sliderList.addEventListener('scroll', this.onListScroll.bind(this));
  },

  addToCart: function () {
    const variantId = this.getAttribute('data-variant-id');
    CART.addItem(variantId, 1);
  },

  onNavigationClick: function(e) {
    if (e.currentTarget.disabled == true) return;

    const slideWidth = this.slider.querySelector('.home-slider__list > li').getBoundingClientRect().width;

    if (e.currentTarget.classList.contains('next')) {
      this.sliderList.scrollTo({
        left: this.sliderList.scrollLeft + slideWidth,
        behavior: 'smooth'
      })
    } else if(e.currentTarget.classList.contains('prev')) {
      this.sliderList.scrollTo({
        left: this.sliderList.scrollLeft - slideWidth,
        behavior: 'smooth'
      })
    }
  },

  onListScroll: function() {
    if (this.sliderList.scrollLeft  <= 10) {
      this.slider.querySelector('.home-slider--navigation .prev').setAttribute('disabled', true);
    } else {
      this.slider.querySelector('.home-slider--navigation .prev').removeAttribute('disabled');
    }

    if (this.sliderList.scrollLeft >= (this.sliderList.scrollWidth - this.sliderList.clientWidth - 10)) {
      this.slider.querySelector('.home-slider--navigation .next').setAttribute('disabled', true);
    } else {
      this.slider.querySelector('.home-slider--navigation .next').removeAttribute('disabled');
    }
  }
};

const STICKY = {
  init: function () {
    this.threshold = 150;
    this.bar = document.querySelector('.sticky-bar');
    if (!this.bar) {
      return;
    }

    this.images = this.bar.querySelector('.sticky-images');
    this.colorButton = this.images.querySelector('button');
    this.colorLinks = this.images.querySelectorAll('a');
    this.pdpAddButton = document.querySelector('.product .product__actions .button[name="add"]');

    this.colorButton.addEventListener('click', this.toggleColor.bind(this));
    this.bar.querySelector('form').addEventListener('submit', this.submit.bind(this));

    this.checkpdpAddButtonPositon();
    window.addEventListener('scroll', this.onScroll.bind(this));
  },

  toggleColor: function () {
    this.images.classList.toggle('sticky-images--is-active');
    if (this.images.classList.contains('sticky-images--is-active')) {
      this.colorLinks.forEach((link) => {
        link.removeAttribute('tabindex');
      });
    } else {
      this.colorLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }
  },

  submit: function (event) {
    event.preventDefault();
    const stickyVariant = document.getElementById('sticky-variant');
    CART.addItem(stickyVariant.value, 1);
  },

  onScroll: function (event) {
    this.checkpdpAddButtonPositon();
  },

  checkpdpAddButtonPositon: function () {
    if (this.pdpAddButton) {
      if (
        this.pdpAddButton.getBoundingClientRect().top > 10 &&
        this.pdpAddButton.getBoundingClientRect().top < window.innerHeight - 10
      ) {
        this.bar.classList.remove('active');
      } else {
        this.bar.classList.add('active');
      }
    }
  },
};

const STORES = {
  init: function () {
    this.stores = document.querySelector('.home-stores__list');
    if (!this.stores) {
      return;
    }
    const buttons = this.stores.querySelectorAll('button');
    buttons.forEach((button) => {
      button.addEventListener('click', this.show.bind(button));
    });
  },

  show: function () {
    const selected = this.closest('ul').querySelector('.home-stores__item--is-selected');
    if (selected) {
      selected.classList.remove('home-stores__item--is-selected');
    }
    this.closest('li').classList.add('home-stores__item--is-selected');
  },
};

const TOGGLE = {
  init: function () {
    document.querySelectorAll('.heading').forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.classList.toggle('active');
        this.slideToggle(heading.nextElementSibling);
      });
    });
  },

  slideToggle: function (target) {
    if (window.getComputedStyle(target).display === 'none') {
      target.style.display = 'block';
    } else {
      target.style.display = 'none';
    }
  },
};

const VIDEO = {
  init: function () {
    const videos = document.querySelectorAll(
      '.block__inspiration video, .static-banner-simple video, .static-banner .active-video video, .image-video-block video, .top-banner video, .home-banner__video video'
    );
    if (!videos) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play();
          } else {
            entry.target.pause();
          }
        });
      },
      {
        threshold: 0.25,
      }
    );
    videos.forEach((video) => {
      observer.observe(video);
    });
  },
};

const OUR_CREATORS = {
  init: function () {
    this.slider = document.querySelector('.our-creators__slider');
    if (!this.slider) {
      return;
    }
    const buttons = this.slider.querySelectorAll('button[data-variant-id]');
    buttons.forEach((button) => {
      button.addEventListener('click', this.addToCart.bind(button));
    });
  },

  addToCart: function () {
    const variantId = this.getAttribute('data-variant-id');
    CART.addItem(variantId, 1);
  },
};

const GIFT_MODAL = {
  init: function () {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            node.addEventListener('click', (event) => {
              if (event.target.classList.contains('docapp-add-to-cart')) {
                const continueButton = document.querySelector('.docapp-gift-choice-modal-done-button');
                if (continueButton) {
                  continueButton.click();
                  window.location.reload();
                }
              }
            });
          });
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  ADVENTURE.init();
  ANNOUNCEMENT.init();
  BACKTOTOP.init();
  CARD.init();
  CART.init();
  COLLAPSIBLE.init();
  FOOTER.init();
  HORIZONTALSCROLL.init();
  LANGUAGE.init();
  MENU.init();
  PRODUCT.init();
  STATICBANNERTOGGLE.init();
  SLIDER.init();
  STICKY.init();
  STORES.init();
  TOGGLE.init();
  VIDEO.init();
  OUR_CREATORS.init();
  GIFT_MODAL.init();
});
